module.exports = __webpack_public_path__ + "static/img/y5.4f4b1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/y5.png
// module id = ehT8
// module chunks = 10